export default __webpack_public_path__ + "static/media/tasha.9d0544af.png";